import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-none font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-black disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-black text-white hover:bg-neutral-800 border border-transparent',
    secondary: 'bg-neutral-100 text-black hover:bg-neutral-200 border border-transparent',
    outline: 'border border-neutral-200 bg-transparent hover:border-black text-black',
    ghost: 'hover:bg-neutral-50 text-neutral-600 hover:text-black'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-344">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-345" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-346">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-347">{rightIcon}</span>}
    </button>;
}